import { assignIfExists } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '@/datasets/constants';
import { findSubscriber } from './state';

const updateDatasetSubscribedToName = withDraft((draft, { code, result }) => {
  const item = findSubscriber(draft, { category: 'dataset', code });
  if (item) {
    assignIfExists(item, { name: result.catalogue.title });
  }
});

export default {
  [actions.UPDATE_DATASET_CATALOGUE_SUCCESS]: updateDatasetSubscribedToName,
  [actions.UPDATE_DATASET_SUCCESS]: updateDatasetSubscribedToName,
};
